import { render, staticRenderFns } from "./campaignGiveaway.vue?vue&type=template&id=3675c475&"
import script from "./campaignGiveaway.vue?vue&type=script&lang=js&"
export * from "./campaignGiveaway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports